import React, { useState, useEffect, useRef } from "react";
import MainNavBar from "./topBar/MainNavBar";
import MainSideBar from "./sideMenu/MainSideBar";
import { useSidebar } from "../utils/helpers/SidebarContext";
import { Outlet } from "react-router-dom";

const MainLayout: React.FC = () => {
  const { isOpen } = useSidebar();
  const [lastScrollTop, setLastScrollTop] = useState<number>(0);
  const contentRef = useRef<HTMLDivElement | null>(null);

  const handleScroll = () => {
    const scrollTop = contentRef.current?.scrollTop || 0;
    setLastScrollTop(scrollTop);
  };

  useEffect(() => {
    const contentElement = contentRef.current;
    contentElement?.addEventListener("scroll", handleScroll);
    return () => {
      contentElement?.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollTop]);

  return (
    <>
      <div className="bg-yt-body h-screen min-h-screen max-h-screen">
        <div className="block">
          <MainNavBar />
        </div>
        <div className="flex">
          <div
            className={`${
              isOpen
                ? "w-auto transition-all duration-400"
                : "w-20 transition-all duration-400"
            }`}
          >
            <MainSideBar isOpen={isOpen} />
          </div>
          <main
            className="flex-1 overflow-y-auto h-[calc(100vh-80px)] rounded-md shadow-sm bg-white border border-primary-50 scrollbar-hide mx-3 mt-3"
            ref={contentRef}
          >
            <Outlet />
          </main>
        </div>
      </div>
    </>
  );
};

export default MainLayout;
